<template>
   <YLayoutBodyMenu :menu="[
       {title:'基础设置',path:'/shop/plugin/team-manage/conf'},
       {title:'等级设置',path:'/shop/plugin/team-manage/level'},
       {title:'用户管理',path:'/shop/plugin/team-manage/manage'},
   ]">
     <router-view/>
   </YLayoutBodyMenu>
</template>

<script>
import YLayoutBodyMenu from "@/components/layouts/YLayoutBodyMenu";
export default {
  name: "index",
  components: {YLayoutBodyMenu},
}
</script>

<style scoped>

</style>